module.exports = __webpack_public_path__ + "fonts/Latinka-ExtraBold.7214861d.ttf";